import type { ReactNode } from 'react';

type ChipTipo = 'success' | 'warning' | 'danger' | 'secondary' | 'info' | 'neutro';

const CORES: Record<ChipTipo, string> = {
  success: 'bg-success-100 text-success-800',
  warning: 'bg-warning-100 text-warning-800',
  danger: 'bg-danger-100 text-danger-800',
  secondary: 'bg-secondary-100 text-secondary-700',
  info: 'bg-info-100 text-info-800',
  neutro: 'bg-secondary-100 text-secondary-700',
};

const PONTO: Record<ChipTipo, string> = {
  success: 'bg-success-500',
  warning: 'bg-warning-500',
  danger: 'bg-danger-500',
  secondary: 'bg-secondary-400',
  info: 'bg-info-500',
  neutro: 'bg-secondary-400',
};

const SUCESSO = [
  'pago', 'paga', 'confirmada', 'confirmado', 'entregue', 'liberado',
  'concluido', 'concluída', 'ativo', 'ok', 'inscrito',
];
const AVISO = ['pendente', 'aguardando', 'em_breve', 'em_andamento'];
const ERRO = [
  'cancelada', 'cancelado', 'expirado', 'estornado', 'estornada',
  'recusado', 'recusada', 'erro', 'falhou', 'vencido',
];

function statusParaTipo(status: string): ChipTipo {
  const s = status.toLowerCase().trim();
  if (SUCESSO.includes(s)) return 'success';
  if (AVISO.includes(s)) return 'warning';
  if (ERRO.includes(s)) return 'danger';
  if (s === 'rascunho') return 'secondary';
  return 'neutro';
}

interface ChipProps {
  tipo?: ChipTipo;
  status?: string;
  children: ReactNode;
  className?: string;
}

export default function Chip({ tipo, status, children, className = '' }: ChipProps) {
  const t = tipo ?? (status ? statusParaTipo(status) : 'neutro');
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${CORES[t]} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${PONTO[t]}`} />
      {children}
    </span>
  );
}